module.exports = __webpack_public_path__ + "static/media/noTry.7ac7cb14.svg";